import { Injectable } from '@angular/core';
import * as CryptoTS from 'crypto-ts';


@Injectable()
export class SessionHelperService {
  key: string = "z!!!#$%^1sdfadsf56adf456asdfasdf";
  appProperties = {
    VALUES: {
      KEY: "M*&^%$#@Nzg5MEFCQ0RFRkdISUpLTE1O",
      IV: "MTIz#$%2Nzg="
    }
  }
  constructor() { }
  public static encryptionAES(msg) {
    // Encrypt
    const ciphertext = CryptoTS.AES.encrypt(msg, 'TEJOORG@N!Z@T!ON123');
    return ciphertext.toString();
  }

  public static decryptionAES(msg) {
    if (!msg || typeof msg !== 'string') {
      return null;
    }
    try {
      // Decrypt
      const bytes = CryptoTS.AES.decrypt(msg, 'TEJOORG@N!Z@T!ON123');
      const plaintext = bytes.toString(CryptoTS.enc.Utf8);
      return plaintext || null;
    } catch (error) {
      return null;
    }
  }

  public static saveSessionVariable(key: string, value: string) {
    sessionStorage.setItem(this.encryptionAES(key), this.encryptionAES(value));
    //sessionStorage.setItem(key, value);
  }

  public static removeSessionVariable(key: string) {
    var encKey = Object.keys(sessionStorage).find(c => this.decryptionAES(c) == key);
    if (encKey) {
      sessionStorage.removeItem(encKey);
    } else {
      sessionStorage.removeItem(key);
    }
  }

  public static readSessionVariable(key: string) {
    try {
      // return sessionStorage.getItem(key);
      var encKey = Object.keys(sessionStorage).find(c => this.decryptionAES(c) == key);
      if (encKey) {
        let value = sessionStorage.getItem(encKey);
        if (value) {
          let pv = this.decryptionAES(value);
          return pv || value;
        }
        else
          return null;
      }
      else {
        const directVal = sessionStorage.getItem(key);
        if (directVal) {
          const decrypted = this.decryptionAES(directVal);
          return decrypted || directVal;
        }
        return null;
      }
    } catch (error) {
      console.warn('Error reading session variable:', error);
      return null;
    }
  }

  public static saveSessionVariableOnlyKeyEncryption(key: string, value: string) {
    sessionStorage.setItem(this.encryptionAES(key), value);
    //sessionStorage.setItem(key, value);
  }

  public static readSessionVariableOnlyKeyEncryption(key: string) {
    try {
      // return sessionStorage.getItem(key);
      var encKey = Object.keys(sessionStorage).find(c => this.decryptionAES(c) == key);
      if (encKey) {
        let value = sessionStorage.getItem(encKey);
        return value || null;
      }
      else {
        return sessionStorage.getItem(key);
      }
    } catch (error) {
      console.warn('Error reading session variable (key only encryption):', error);
      return null;
    }
  }

  public static clearSession() {
    sessionStorage.clear();
  }

}
